<template>
  <div class="my-prize">
    <img
      class="toast-bg"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/b30bf287f0ecd9587180b3370a972c36_wh=1125_870.png"
      alt=""
    />
    <img
      class="title-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/209b3b3e09f3a9723f0d811ca799db53_wh=471_186.png"
      alt=""
    />
    <div class="close" @click="bindClose"
      ><span class="iconfont icon-cha"></span
    ></div>
    <div class="prize-scroll">
      <div class="prize-list" v-if="computePrizeList">
        <div
          class="prize-item"
          v-for="(item, index) in computePrizeList"
          :key="index"
        >
          <div class="item-top">
            <img class="item-image" :src="item.reward_image" alt="" />
            <div class="item-right">
              <div class="item-name">{{ item.reward_name }}</div>
              <div class="item-desc">{{ item.reward_describe }}</div>
            </div>
          </div>
          <div class="item-bottom" v-if="item.reward_type == 6">
            <div class="receive-btn" @click="bindReceive(item)">去领取</div>
          </div>
        </div>
        <div class="empty" v-if="!computePrizeList.length">
          <img
            class="empty-image"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/c6909e87377d090f266d8b1e7f1852c5_wh=642_339.png"
            alt=""
          />
          <div class="empty-text">暂无奖品</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {}
  },
  watch: {
    show() {
      if (this.show) {
        this.$store.dispatch('coachActivity2024/actionPrizeList')
      }
    }
  },
  computed: {
    computePrizeList() {
      return this.$store.state.coachActivity2024.myPrizePage.prizeList
    },
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    }
  },
  watch: {},
  created() {},
  methods: {
    bindSendFlower() {},
    bindReceive(item) {
      this.$http.addDataLog({
        eventk: 'CLICK_huodong_COACH_xhh_tyk',
        eventv: ''
      })
      setTimeout(() => {
        location.href =
          'https://work.weixin.qq.com/ca/cawcdee55662b9cd58?customer_channel=qywx_ca:107940455'
      }, 400)
    },
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.my-prize {
  position: relative;
  z-index: 1;
  background: linear-gradient(178deg, #ffc0dc 0%, #fff3f8 100%);
  border-radius: 8px 8px 0px 0px;
  padding-top: 95px;
  padding-bottom: 50px;
  box-sizing: border-box;
  .toast-bg {
    z-index: -1;
    width: 100%;
    left: 0;
    top: -26px;
    position: absolute;
  }
  .title-image {
    z-index: -1;
    width: 157px;
    left: 20px;
    top: 20px;
    position: absolute;
  }
  .prize-scroll {
    min-height: 148px;
    max-height: 508px;
    overflow-y: scroll;
    .prize-list {
      overflow: hidden;
      padding: 0px 12px 0px;
      .prize-item {
        padding: 12px;
        background: #ffffff;
        border-radius: 8px;
        margin-bottom: 10px;
        .item-top {
          display: flex;
          align-items: center;

          .item-image {
            width: 60px;
            height: 60px;
            object-fit: cover;
            border-radius: 4px;
            overflow: hidden;
            margin-right: 10px;
          }
          .item-right {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            .item-name {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-weight: bold;
              font-size: 14px;
              color: #050b27;
              line-height: 20px;
              margin-bottom: 6px;
            }
            .item-desc {
              font-size: 12px;
              color: rgba(5, 11, 39, 0.4);
              line-height: 17px;
            }
          }
        }
        .item-bottom {
          margin-top: 12px;
          .receive-btn {
            height: 28px;
            background: #ff2270;
            border-radius: 14px;
            font-weight: 500;
            font-size: 12px;
            color: #ffffff;
            line-height: 28px;
            text-align: center;
          }
        }
      }
      .prize-item:last-child {
        margin-bottom: 0;
      }
    }
    .empty {
      width: 100%;
      height: 272px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .empty-image {
        width: 214px;
        height: 112px;
        object-fit: contain;
        margin-bottom: 25px;
      }
      .empty-text {
        font-weight: bold;
        font-size: 16px;
        color: rgba(5, 11, 39, 0.5);
        line-height: 22px;
      }
    }
  }
  .close {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-weight: bold;
      font-size: 20px;
      color: rgba(48, 48, 56, 1);
    }
  }
}
</style>
